/**
 * 與 PC 用戶端一致：game code → member/* 的 lottery 參數
 */
export const GAME_CODE_TO_LOTTERY = Object.freeze({
  ssc: 'SSCJSC',
  lucky_airship: 'XYFT',
  speed_car: 'PK10JSC',
  speed_airship: 'LUCKYSB',
  aus5: 'AULUCKY5',
  aus10: 'AULUCKY10',
  jnd2: 'JND2',
  pc28dwp: 'PC28',
  jsft: 'FTJSC',
})

export const LOTTERY_ID_TO_GAME_CODE = Object.freeze(
  Object.fromEntries(Object.entries(GAME_CODE_TO_LOTTERY).map(([a, b]) => [b, a])),
)

/** 手機大廳 / GamePlay 頂欄名稱 → 與 PC 一致的 code（鍵含數字小數點須加引號） */
export const MOBI_LOTTERY_TITLE_TO_CODE = Object.freeze({
  极速时时彩: 'ssc',
  幸运飞艇: 'lucky_airship',
  极速赛车: 'speed_car',
  极速飞艇: 'speed_airship',
  澳洲幸运5: 'aus5',
  澳洲幸运10: 'aus10',
  '加拿大2.0': 'jnd2',
  PC28大网盘: 'pc28dwp',
  /** 與 member/lotterys 後台別名對齊，避免下拉/接口名與產品名不一致時無法解析 */
  // 极速蛋蛋: 'pc28dwp',
  极速番摊: 'jsft',
})

/** 後台 lottery 名與產品名不一致時，大廳/報表仍用 MOBI_GAME_DEFS 的 title */
export const GAME_CODE_USE_CANONICAL_TITLE = Object.freeze(new Set(['pc28dwp']))
